import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchUsers} from "../../../../actions";
import {bbDangerousStringToDate, bbFormattedDateString} from "../../../../util/bbHelpers";
import BBDataTable from "../../tables/BBDataTable";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {KeyboardDatePicker} from "@material-ui/pickers";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";

const Tile = (props) =>{

    //select users object from state
    const { users, loadingUsers } = useSelector(({users})=> users);
    const dispatch = useDispatch();
    const [date, setDate] = useState(new Date(Date.now()- 30 * 24 * 60 * 60 * 1000));


    //api call gets users object from state-- users is an object that contains user data objects as key/value pairs
    useEffect(()=>{
        if(!users && !loadingUsers){
            dispatch(fetchUsers())
        }
    }, [users, dispatch, loadingUsers])

    //function compares two dates and return the number of days different

    // const calcDiffDays = (object, dateKey) => {
    //     const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    //
    //     // const firstDate = object[dateKey];
    //     const firstDate = bbDangerousStringToDate(object[dateKey], false)
    //
    //     const secondDate = new Date();
    //
    //     return Math.round(Math.abs((firstDate - secondDate) / oneDay));
    // }

    const usersArray = users && Object.values(users)
    //newUsers (array) is equal to the array created by "flattening" the users object into an array containing the user objects and then filtering
    //the array into users created in the last 7 days
    const newUsers = users
        && usersArray
        && Array.isArray(usersArray)
        && usersArray.filter(user=> new Date(user["date_joined"]) > date);
    // console.log("newusers pre sort", newUsers)
    newUsers && newUsers.sort((a,b)=> {
        return bbDangerousStringToDate(b.date_joined) - bbDangerousStringToDate(a.date_joined)})
    // console.log(newUsers)

    //title variable is for datatable, includes html formatting for title and relevant tooltip
    const title = <div>
        New Users Information <Tooltip title={"Information about newest users"}>
        <InfoSharpIcon style={{fontSize:"smaller"}}/>
    </Tooltip>
    </div>


    //tableheadings is an array of objects passed the data table, each object represents the column headings of the table
    const userTableHeadings = [
        { field: 'id', headerName: 'User Id', hide: true, flex: 2, sortable: true, type: 'number', },
        { field: 'first_name', headerName: "First Name", hide: false, flex: 2, sortable: false, type: "string"},
        { field: 'last_name', headerName: "Last Name", hide: false, flex: 2, sortable: false, type: "string"},
        { field: 'date_joined', headerName: 'Date', hide: false, flex: 2, sortable: true, type: 'date',
            renderCell: (params) =>
                renderCellExpand(params, (bbFormattedDateString(params.value, "short")))},
        { field: 'email', headerName: "Email", hide: false, flex: 4, sortable: false, type: "string"}
    ]

    //
    // users && console.log(Object.values(users).map((user)=> calcDiffDays(user, "date_joined")))
    // users && console.log(Object.values(users).map((user)=> user["date_joined"]))
    // users && console.log(Object.values(users).map((user)=> bbDangerousStringToDate(user["date_joined"])))



    //BBDataTable is based on Materials Ui data grid, find component @ /components/customBreachBits/tables
    return(
        <div>
            {users && newUsers ?
                (
                    <BBDataTable
                        columns={userTableHeadings}
                        rows={newUsers}
                        title={title}
                        totalRows={newUsers.length}
                        // topRightElement={<Tooltip title={"information for newest users"}/>}
                        progressValue={100}
                        loading={false}
                        rowsPerPageOptions = {[ 5, 10, 25, 50]}
                        defaultPageSize = {10}
                        defaultSortModel = {[
                            {
                                field: 'date_joined',
                                sort: 'asc',
                            },

                        ]}
                        topRightElement={<KeyboardDatePicker
                            margin="normal"
                            id="date"
                            name="date"
                            label={"New Users Since"}
                            format="MM/DD/yyyy"
                            value={date}
                            maxDate={new Date(Date.now())}
                            onChange={(date) => setDate(date)}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}/>}
                        >
                    </BBDataTable>
                ):
                (<BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    title={title}
                    loading = {false}
                    totalRows={0}
                    progressValue={100}
                    bufferValue={0}
                    rowsPerPageOptions = {[5, 10, 25, 50]}
                    defaultPageSize = {10}
                    defaultSortModel = {[
                        {
                            field: 'date_joined',
                            sort: 'desc',
                        },

                    ]}
                    topRightElement={<KeyboardDatePicker
                        margin="normal"
                        id="date"
                        name="date"
                        label={"New Users Since"}
                        format="MM/DD/yyyy"
                        value={date}
                        maxDate={new Date(Date.now())}
                        onChange={(date) => setDate(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}/>}
                />)}
        </div>

    )

}

export default Tile;